import React from 'react';
import DataTable from 'react-data-table-component';
import { columns } from './_components/columns';
import { tableCustomStyles } from './_components/styles';
import { Actions } from './_components/actions';
import { CouponsPagination } from './_components/CouponsPagination';
import { useCouponsBootstrap } from './coupons.bootstrap.hook';

export function CouponsJussub() {
  const {
    canAccess,
    data,
    loading,
    totalRows,
    perPage,
    filterText,
    resetPaginationToggle,
    initialParams,
    handlePageChange,
    handlePerRowsChange,
    handleAddCouponButton,
    handleFilterChange,
    handleClearFilter,
  } = useCouponsBootstrap();

  if (!canAccess.flagResolved) {
    return null;
  }

  if (!canAccess.isFeatureFlagEnable) {
    return (
      <div>
        <span>Página não disponível no momento!</span>
      </div>
    );
  }

  return (
    <>
      <h1 className="azul-cabecalho">Cupom</h1>
      <p className="subheader-text mb-10">Listagem de cupons do JusSub</p>

      <div className="card card-custom">
        <div style={{ overflowX: 'auto', width: '100%' }}>
          <DataTable
            columns={columns}
            data={data}
            customStyles={tableCustomStyles}
            progressPending={loading}
            pagination
            perPage={perPage}
            paginationServer
            paginationDefaultPage={initialParams.page}
            paginationTotalRows={totalRows}
            paginationResetDefaultPage={resetPaginationToggle}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={
              <Actions
                filterText={filterText}
                onFilter={handleFilterChange}
                onClear={handleClearFilter}
                onAddClick={handleAddCouponButton}
              />
            }
            paginationComponent={CouponsPagination}
            responsive={false}
            style={{ width: '100%' }}
          />
        </div>
      </div>
    </>
  );
}
